/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  OutlinedInput,
  TableCell,
  TableRow
} from "@mui/material";
import {
  Add,
  Cancel,
  Check,
  Clear,
  Commit,
  Contacts,
  CreditCard,
  Done,
  Edit,
  LocalAtm,
  NearMe,
  Pause,
  PlayArrow,
  Visibility,
  Apartment,
  Person
} from "@mui/icons-material";
import {
  dateDifference,
  formatCurrency,
  getLeaseRefNumber,
  isArray,
  isEmptyArray,
  isEmptyString,
  isNullUndefined,
  sortAlphaNum
} from "../util/util";
import "dayjs/locale/en-gb";
import { useSelector } from "react-redux";
import Permit from "../util/permit";
import ReceivePayment from "../components/modals/receivePayment";
import ContractTermination from "../components/contractTermination";
import {
  activateLease,
  addLeaseContact,
  deleteDraftLease,
  downloadLeases,
  exportLeases,
  getLeaseContacts,
  getLeaseDetails,
  getLeases,
  getTotalLeases,
  leaseTermination,
  removeLeaseContact,
  resendLastInvoice,
  resendLastReceipt,
  resendStatement,
  saveLeaseNote,
  saveLeasePayment,
  suspendReactivateLease,
  getRsrs,
} from "../services/lease.service";
import {
  TopBarContainedBrandButton,
  TopBarContainer,
} from "../constants/component.constants";
import AddNewUser from "../components/modals/addNewUser";
import ConfirmationModal from "../components/modals/confirmation";
import LeaseView from "./leaseView";
import ExportDocumentsModal from "../components/modals/exportDocuments";
import CreditNote from "../components/modals/creditNote";
import DebitNote from "../components/modals/debitNote";
import { amber, deepOrange, green, red } from "@mui/material/colors";
import { renderCellExpand } from "../util/renderCellExpand";
import AddNoteModal from "../components/modals/rentals/leases/addNoteModal";
import SuspendLeaseModal from "../components/modals/rentals/leases/suspendLeaseModal";
import LeaseUnitSwapModal from "../components/modals/rentals/leases/leaseUnitSwapModal";
import AddLeaseModal from "../components/modals/rentals/leases/addLeaseModal";
import { ResponsiveRow } from "../constants/layout.constants";
import IncrementRentModal from "../components/modals/rentals/leases/incrementRentModal";
import SplitButton from "../components/splitButton";
import { issueResponseMessage, issueWarnMessage } from "../actions/message";
import ContractContactModal from "../components/modals/contractContactModal";
import { saveNewContactPerson } from "../services/users.service";
import dayjs from "dayjs";
import MuiDataGrid from "../components/modules/MuiDataGrid";

export default function Leases() {
  const [leases, setLeases] = useState([]);
  const [searchReference, setSearchReference] = useState("");
  const [searchTenant, setSearchTenant] = useState("");
  const [searchUnit, setSearchUnit] = useState("");
  const [loading, setLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 50,
    page: 0,
  });
  const [totalLeases, setTotalLeases] = useState(0);
  const [selectedLease, setSelectedLease] = useState(null);
  const [includeLeaseDetail, setIncludeLeaseDetail] = useState(false);
  const [terminateItem, setTerminateItem] = useState(null);
  const [suspendModal, setSuspendModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showIncrementRentModal, setShowIncrementRentModal] = useState(false);
  const [statusChangeReason, setStatusChangeReason] = useState("");
  const [addUserModal, setAddUserModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [creditModal, setCreditModal] = useState(false);
  const [statementYear, setStatementYear] = useState(new Date());
  const [contactTableRows, setContactTableRows] = useState();
  const [chargeModal, setChargeModal] = useState(false);
  const [bulkChargeAction, setBulkChargeAction] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [terminateModal, setTerminateModal] = useState(false);
  const [note, setNote] = useState("");
  const [task, setTask] = useState("");
  const [contactModal, setContactModal] = useState(false);
  const [showAddNewContact, setShowAddNewContact] = useState(false);
  const [isTenantSelect, setIsTenantSelect] = useState(false);
  const [isTenantAdd, setIsTenantAdd] = useState(false);
  const [isContactSelect, setIsContactSelect] = useState(false);
  const [idTypeSearch, setIdType] = useState("");
  const [idNoSearch, setIdNo] = useState("");
  const user = useSelector((state) => state.auth.user);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [leaseContacts, setLeaseContacts] = useState([]);
  const [titleText, setTitleText] = useState("");
  const [severityText, setSeverityText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [positiveText, setPositiveText] = useState("");
  const [negativeText, setNegativeText] = useState("");
  const [voiditem, setVoiditem] = useState(null);
  const [rsrs, setRsrs] = useState([]);

  const handlePaymentClose = () => setPaymentModal(false);

  const handleCreditClose = () => {
    setVoiditem(null);
    setCreditModal(false);
    //reload page after issuing a credit
    setLoading(true);
    getLeases(
      searchReference,
      searchTenant,
      searchUnit,
      paginationModel.page,
      paginationModel.pageSize,
    )
      .then((result) => {
        setLeases(result);
        setTask("")
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChargeClose = () => {
    setVoiditem(null);
    setChargeModal(false);
    setBulkChargeAction(false);
    //reload page after issuing a charge
    fetchLeases();
  };

  const handleContactClose = () => {
    setIsContactSelect(false);
    setIdType("");
    setIdNo("");
    setContactModal(false);
    setShowAddNewContact(false);
    setLeaseContacts([]);
  };
  const handleSuspendReactivateClose = () => {
    setTask("");
    setSuspendModal(false);
  };
  const handleContactClear = () => {
    setIdType("");
    setIdNo("");
  };
  const handleNoteClose = () => {
    setNote(""); //Clear note
    setNoteModal(false);
  };
  const handleDownloadClose = () => {
    setRowSelectionModel([]); //Clear selection
    setStatementYear(new Date());
    setIncludeLeaseDetail(false);
    setDownloadModal(false);
    setTitleText("");
    setTask("");
    setSeverityText("");
    setBodyText("");
  };

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
    setTitleText("");
    setTask("");
    setSeverityText("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
    setSelectedLease(null);
    setRowSelectionModel([]);
  };

  const handleTerminateClose = () => {
    setTerminateModal(false);
  };

  const handleIncrementRentClose = () => {
    setRowSelectionModel([]);
    setShowIncrementRentModal(false);
  };

  const handleAddLeaseClose = async (reload = false) => {
    setSelectedLease(null);
    setTask("");
    if (reload === true) {
      fetchLeases();
    }
  };

  const handleSwapLeaseUnitClose = async (reload = false) => {
    setSelectedLease(null);
    setTask("");
    if (reload === true) {
      fetchLeases();
    }
  };

  const resendButtons = [
    {
      label: "RESEND ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: () => handleSendLeaseDocClick("Invoice"),
      label:
        rowSelectionModel.length > 1
          ? "Resend " + rowSelectionModel.length + " Invoices"
          : "Resend Last Invoice",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
    {
      action: () => handleSendLeaseDocClick("Receipt"),
      label:
        rowSelectionModel.length > 1
          ? "Resend " + rowSelectionModel.length + " Receipt"
          : "Resend Last Receipt",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
    {
      action: () => handleSendLeaseDocClick("Statement"),
      label:
        rowSelectionModel.length > 1
          ? "Resend " + rowSelectionModel.length + " Statements"
          : "Resend Statement",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 0,
    },
  ];

  const leaseButtons = [
    {
      label: "LEASE ACTIONS",
      roles: false,
      services: false,
    },
    {
      action: () => handleIncrementRentClick(),
      label:
        rowSelectionModel.length > 1
          ? "Increment Rent for " + rowSelectionModel.length + " leases"
          : "Increment Rent",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 1,
    },
    {
      action: handleDownloadClick,
      label:
        rowSelectionModel.length > 1
          ? "Export " + rowSelectionModel.length + " Lease Statements"
          : "Export Lease Statement",
      roles: false,
      services: false,
      disabled: rowSelectionModel.length <= 1,
    },
    {
      action: bulkCharge,
      label:
        rowSelectionModel.length > 1
          ? "Issue Charges to " + rowSelectionModel.length + " Leases"
          : "Issue Charge",
      roles: "BLDIR,BLDMG,CS",
      services: false,
      disabled: rowSelectionModel.length <= 1,
    },
    {
      action: exportLeaseData,
      label: "Download All Leases",
      roles: false,
      services: false,
    },
  ];

  const fetchLeases = async (controller = null) => {
    try {
      setLoading(true);
      const [totalLeasesResponse, leasesResponse] = await Promise.all([
        getTotalLeases(searchReference, searchTenant, searchUnit, {
          signal: controller?.signal,
        }),
        getLeases(
          searchReference,
          searchTenant,
          searchUnit,
          paginationModel.page,
          paginationModel.pageSize,
          { signal: controller?.signal },
        ),
      ]);

      if (controller?.signal?.aborted) return;

      if (totalLeasesResponse?.totalLeases !== undefined) {
        setTotalLeases(totalLeasesResponse.totalLeases);
      }
      if (leasesResponse !== undefined) {
        setLeases(leasesResponse);
      }
    } catch (error) {
      if (
        error?.code === "ERR_CANCELED" ||
        error?.name === "CanceledError" ||
        error?.name === "AbortError"
      ) {
        return;
      }
      console.error("Failed to fetch data:", error);
    } finally {
      if (!controller?.signal?.aborted) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if(!isNullUndefined(user.proxyFacility) && !isEmptyString(user.proxyFacility)) {
      const controller = new AbortController();
      const timerId = setTimeout(() => {
        // Only start loading if the data fetching is truly new
        fetchLeases(controller);
      }, 500);

      return () => {
        // Cleanup function
        clearTimeout(timerId);
        controller.abort();
      };
    }
  }, [
    user.proxyFacility,
    searchReference,
    searchTenant,
    searchUnit,
    paginationModel.page,
    paginationModel.pageSize,
  ]);

  useEffect(() => {
    if (!isNullUndefined(selectedLease) && !isNullUndefined(selectedLease.id)) {
      getLeaseContacts(selectedLease.id).then((leaseContacts) =>
        setLeaseContacts(leaseContacts),
      );
    }

    if (!isNullUndefined(selectedLease) && selectedLease.hasRevenueSharing) {
      getRsrs(selectedLease.id).then((result) => setRsrs(result?.rsrList));
    }
  }, [selectedLease]);

  useEffect(() => {
    populateLeaseContacts();
  }, [leaseContacts]);

  const fetchRsrs = (leaseId) => {
    getRsrs(leaseId).then((result) => setRsrs(result?.rsrList));
  };

  function handleVoidClick(item) {
    if (item.type === "Charge" || item.type === "Invoice") {
      setCreditModal(true);
      //set the id of the transaction being voided
      setVoiditem(item);
    } else if (item.type === "Receipt" || item.type === "Credit") {
      setChargeModal(true);
      setVoiditem(item);
    }
  }

  function showAddNewContactForm(idNoSearch, idTypeSearch) {
    setIdType(idTypeSearch);
    setIdNo(idNoSearch);
    setIsTenantSelect(false);
    setAddUserModal(true);
    setIsContactSelect(true);
  }

  function handleAddUserClose() {
    setAddUserModal(false);
  }

  function handlePersonOrgSelect(result) {
    if (isTenantSelect || isTenantAdd) {
      let obj = selectedLease;
      obj.tenant = result;
      setSelectedLease(obj);
      setIsTenantSelect(false);
      setIsTenantAdd(false);
      setIsContactSelect(false);
      setIdType("");
      setIdNo("");
    }

    if (isContactSelect) {
      setIsTenantSelect(false);
      if (showAddNewContact) {
        saveNewContactPerson(result).then((response) => {
          let data = {
            leaseId: selectedLease.id,
            personId: response.person.id,
          };
          if (validateAddLeaseContact(data)) {
            addLeaseContact(data).then((response) => {
              issueResponseMessage(response);
              getLeaseContacts(selectedLease.id).then((leaseContacts) =>
                setLeaseContacts(leaseContacts),
              );
              handleContactClear();
            });
          }
        });
      } else {
        let data = {
          leaseId: selectedLease.id,
          personId: result.id,
        };
        if (validateAddLeaseContact(data)) {
          addLeaseContact(data).then((response) => {
            issueResponseMessage(response);
            getLeaseContacts(selectedLease.id).then((leaseContacts) =>
              setLeaseContacts(leaseContacts),
            );
            handleContactClear();
          });
        }
      }
    }
  }

  function onTextChange(event) {
    const id = event.target.id;
    const value = event.target.value;
    if (id === "searchRef") {
      setSearchReference(value);
    }
    if (id === "searchTenant") {
      setSearchTenant(value);
    }
    if (id === "note") {
      setNote(value);
    }
    if (id === "idNoSearch") {
      setIdNo(value);
    }
    if (id === "statusChangeReason") {
      setStatusChangeReason(value);
    }
    if(id === "searchUnit") {
      setSearchUnit(value)
    }
  }

  function deleteLease() {
    if (
      isNullUndefined(selectedLease) ||
      isNullUndefined(selectedLease.id) ||
      isEmptyString(selectedLease.id)
    ) {
      issueWarnMessage(
        "Could not determine Lease ID for deletion. Try refresh the page or contact support.",
      );
      return;
    }

    const sendData = { leaseId: selectedLease.id };

    setLoading(true);
    deleteDraftLease(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
      fetchLeases();
    });
  }

  function resendLastInvoiceClicked() {
    if (isEmptyArray(selectedIds)) {
      return issueWarnMessage("No leases selected");
    }
    let sendData = { bulkEditIds: selectedIds };
    resendLastInvoice(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function resendLastReceiptClicked() {
    if (isEmptyArray(selectedIds)) {
      return issueWarnMessage("No leases selected");
    }
    let sendData = { bulkEditIds: selectedIds };
    resendLastReceipt(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function resendStatementClicked() {
    if (isEmptyArray(selectedIds)) {
      return issueWarnMessage("No leases selected");
    }
    let sendData = { bulkEditIds: selectedIds };
    resendStatement(sendData).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
    });
  }

  function activateDraftLease() {
    if (
      isNullUndefined(selectedLease) ||
      isNullUndefined(selectedLease.id) ||
      isEmptyString(selectedLease.id)
    ) {
      issueWarnMessage(
        "Could not determine Lease for activation. Try refresh the page or contact support.",
      );
      return;
    }

    setLoading(true);
    activateLease(selectedLease).then((response) => {
      issueResponseMessage(response);
      handleConfirmationClose();
      fetchLeases();
    });
  }

  function positiveAction() {
    if (task === "Delete") {
      deleteLease();
    }
    if (task === "Activate") {
      activateDraftLease();
    }
    if (task === "Resend Invoice") {
      resendLastInvoiceClicked();
    } else if (task === "Resend Receipt") {
      resendLastReceiptClicked();
    } else if (task === "Resend Statement") {
      resendStatementClicked();
    }
  }

  function suspendReActivateLeaseForm() {
    let data = {
      leaseId: selectedLease.id,
      statusChangeReason: statusChangeReason, //CASH/CHEQUE - only needed if final balance < 0
      currentStatus: selectedLease.status,
    };
    if (isEmptyString(data.statusChangeReason)) {
      issueWarnMessage("Cannot submit an without a reason for suspension");
      return false;
    }
    suspendReactivateLease(data).then((response) => {
      issueResponseMessage(response);
      if (!isNullUndefined(response.lease)) {
        fetchLeases();
        handleSuspendReactivateClose();
      }
    });
  }

  function handleIncludeLeaseDetailToggle(event) {
    setIncludeLeaseDetail(event.target.checked);
  }

  function handleLeaseContactRemove(personId) {
    if (
      isNullUndefined(selectedLease) ||
      isNullUndefined(selectedLease.id) ||
      isEmptyString(selectedLease.id)
    ) {
      issueWarnMessage(
        "Something went wrong: couldn't find the title to retrieve the contacts. Try refresh the page.",
      );
      return;
    }
    if (isNullUndefined(personId) || isEmptyString(personId)) {
      issueWarnMessage(
        "Couldn't find the person identifier. Try refresh the page",
      );
      return;
    }
    let data = {
      leaseId: selectedLease.id,
      personId: personId,
    };
    removeLeaseContact(data).then((response) => {
      issueResponseMessage(response);
      getLeaseContacts(selectedLease.id).then((leaseContacts) =>
        setLeaseContacts(leaseContacts),
      );
      handleContactClear();
    });
  }

  function handlePaymentClick(selectedLease) {
    setSelectedLease(selectedLease);
    setPaymentModal(true);
  }

  function handleTerminateClick(selectedLease) {
    let data = {
      leaseId: selectedLease.id,
      paymentMethod: "", //CASH/CHEQUE - only needed if final balance < 0
      cashAccountId: "", //When Cash, must select which account
      chequeNumber: "", // When Cheque
      bankRefNumber: "", // For RTGS payments
      charges: [],
    };
    setTerminateItem(data);
    setSelectedLease(selectedLease);
    setTerminateModal(true);
  }

  function handleNoteClick(selectedLease) {
    setSelectedLease(selectedLease);
    setNoteModal(true);
  }

  function handleCreditClick(selectedLease) {
    setSelectedLease(selectedLease);
    setCreditModal(true);
  }

  function handleContactClick(selectedLease) {
    setSelectedLease(selectedLease);
    setShowAddNewContact(true);
    setContactModal(true);
    setIsContactSelect(true);
  }

  function handleChargeClick(selectedLease) {
    setSelectedLease(selectedLease);
    setChargeModal(true);
  }

  function handleStatementYearChange(value) {
    setStatementYear(value);
  }

  function handleViewClick(selectedLease) {
    getLeaseDetails(selectedLease.id).then((response) => {
      if (!isNullUndefined(response.id)) {
        setSelectedLease(response);
        setTask("View");
      }
    });
  }

  function handleAddLeaseClick() {
    let facilityId = null;
    if (user.proxyFacility != null) {
      facilityId = user.proxyFacility;
    }
    let refNumber = getLeaseRefNumber();
    let data = {
      id: null,
      effectiveDate: "",
      expirationDate: null,
      tenant: {
        id: null,
        name: null,
      },
      facilityId: facilityId,
      unitIds: [],
      statusCd: "DRF",
      billingCode: refNumber,
      leaseTypeCd: null,
      leaseChargeItems: [],
      incrementPeriod: 0, // default to increment after 1 year
    };
    setSelectedLease(data);
    setTask("Create");
  }

  function handleSuspendClick(selectedLease) {
    setSelectedLease(selectedLease);
    setTask("Suspend");
    setSuspendModal(true);
  }

  function handleReActivateClick(selectedLease) {
    setSelectedLease(selectedLease);
    setTask("Re-Activate");
    setSuspendModal(true);
  }

  function handleDeleteDraftLeaseClick(selectedLease) {
    setSelectedLease(selectedLease);
    let title =
      "Confirm Delete Lease " +
      selectedLease.billingCode +
      " for " +
      selectedLease.tenant;
    let body =
      "Are you sure you want to permanently delete this lease along with any other associated data such as charges, contacts, and documents?";
    setTitleText(title);
    setTask("Delete");
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Delete Lease");
    setNegativeText("Cancel");
    setShowConfirmationModal(true);
  }

  function handleActivateDraftLeaseClick(selectedLease) {
    selectedLease.activateAndInvoice = false;
    setSelectedLease(selectedLease);
    let title =
      "Activate Lease " +
      selectedLease.billingCode +
      " for " +
      selectedLease.tenant;
    let body = "Are you sure you wish to Activate this lease?";
    setTitleText(title);
    setTask("Activate");
    setSeverityText("info");
    setBodyText(body);
    setPositiveText("Yes");
    setNegativeText("No");
    setShowConfirmationModal(true);
  }

  function handleEditClick(leaseToEdit) {
    getLeaseDetails(leaseToEdit.id).then((response) => {
      if (!isNullUndefined(response.id)) {
        if (
          isArray(response.leaseChargeItems) &&
          response.leaseChargeItems.length > 0
        ) {
          let opt = [];
          for (let item of response.leaseChargeItems) {
            if (opt.filter((o) => o.value === item.unit.id).length < 1) {
              opt.push({
                label: item.unit.name,
                value: item.unit.id,
              });
            }
          }
        }
        setTask("Edit");
        setSelectedLease(response);
      }
    });
  }

  function handleActiveEditClick(leaseToEdit) {
    getLeaseDetails(leaseToEdit.id).then((response) => {
      if (!isNullUndefined(response.id)) {
        setTask("ActiveLeaseEdit");
        setSelectedLease(response);
      }
    });
  }

  function savePayment(data) {
    data.leaseId = selectedLease.id;
    setLoading(true);
    saveLeasePayment(data)
      .then((response) => {
        issueResponseMessage(response);
        if (!isNullUndefined(response) && !isNullUndefined(response.lease)) {
          fetchLeases();
          handlePaymentClose();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleUnitSwapClick() {
    setTask("Unit Swap");
  }

  function handleIncrementRentClick() {
    setShowIncrementRentModal(true);
  }

  function handleSendLeaseDocClick(docType) {
    let title = "Confirm Send " + docType;
    let body =
      "Are you sure you want to resend the last " +
      docType +
      " for " +
      rowSelectionModel.length +
      " selected lease(s)?";
      if(docType === "Statement"){
      title = "Confirm Resend latest " + docType;
      body =
            "Are you sure you want to resend the latest " +
            docType +
            " for " +
            rowSelectionModel.length +
            " selected lease(s)?";
      }

    setTitleText(title);
    setTask("Resend " + docType);
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Send");
    setNegativeText("Cancel");
    setShowConfirmationModal(true);
    setRowSelectionModel(rowSelectionModel);
    setSelectedIds(rowSelectionModel);
  }

  function exportLeaseData() {
    exportLeases();
  }

  function handleDownloadClick() {
    setDownloadModal(true);
    let title =
      rowSelectionModel.length > 1
        ? "Download " + rowSelectionModel.length + " Leases"
        : "Download Lease";
    let body =
      "Note: Processing the selected Leases may take some time." +
      " Therefore, the exported data will be emailed to you when it is finished being packaged." +
      " Please ensure the email set for your account is valid, working and that you have access to it in order to receive the export data.";
    setTitleText(title);
    setSeverityText("info");
    setBodyText(body);
  }

  function bulkCharge() {
    setChargeModal(true);
    setBulkChargeAction(true);
  }

  function positiveExportDocsAction() {
    downloadLeaseDocs();
  }

  function downloadLeaseDocs() {
    if (isNullUndefined(rowSelectionModel) || rowSelectionModel.length < 1) {
      issueWarnMessage(
        "Could not determine the download items. Please refresh the page and try again.",
      );
      return;
    }
    let data = {
      leaseIds: rowSelectionModel,
      includeLeaseDetails: includeLeaseDetail,
      statementYear: dayjs(statementYear).year(), // e.g. 2022
    };

    downloadLeases(data).then((response) => {
      issueResponseMessage(response);
      handleDownloadClose();
    });
  }

  function populateLeaseContacts() {
    let rows = "";
    leaseContacts &&
      leaseContacts.length > 0 &&
      (rows = leaseContacts.map(function (contact, i) {
        return (
          <TableRow key={i}>
            <TableCell>{contact.name}</TableCell>
            <TableCell>{contact.mobilePhone}</TableCell>
            <TableCell>{contact.email}</TableCell>
            <TableCell>
              <Button
                variant="contained"
                type="submit"
                sx={{ marginLeft: "10px", padding: "4px 8px" }}
                onClick={() => handleLeaseContactRemove(contact.personId)}
                color="error"
              >
                <Cancel />
              </Button>
            </TableCell>
          </TableRow>
        );
      }, this));
    setContactTableRows(rows);
  }

  function validateAddLeaseContact(data) {
    if (isNullUndefined(data.leaseId) || isEmptyString(data.leaseId)) {
      issueWarnMessage(
        "Something went wrong: couldn't find the lease to retrieve the contacts. Try refresh the page.",
      );
      return false;
    }
    if (isNullUndefined(data.personId) || isEmptyString(data.personId)) {
      issueWarnMessage(
        "Couldn't find the person identifier. Try refresh the page",
      );
      return false;
    }
    let personId = data.personId.replace("_P", "");
    let duplicateContact = leaseContacts.find((contact) => {
      return contact.personId === personId;
    });
    if (!isNullUndefined(duplicateContact)) {
      issueWarnMessage(
        "Cannot add a contact that has already been linked to this lease",
      );
      return false;
    }
    return true;
  }

  function saveNote() {
    let data = {
      leaseId: selectedLease.id,
      note: note,
    };
    saveLeaseNote(data).then((response) => {
      issueResponseMessage(response);
      handleNoteClose();
    });
  }

  function terminateLease(data) {
    setLoading(true);
    leaseTermination(data).then((response) => {
      issueResponseMessage(response);
      handleTerminateClose();
      fetchLeases();
    });
  }

  function getChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "DRF") {
        return {
          icon: <Commit style={{ fill: deepOrange[500] }} />,
          label: "Draft",
          style: {
            borderColor: deepOrange[500],
          },
        };
      } else if (params.value === "ACT") {
        return {
          icon: <Check style={{ fill: green[500] }} />,
          label: "Active",
          style: {
            borderColor: green[500],
          },
        };
      } else if (params.value === "SUP") {
        return {
          icon: <Pause style={{ fill: amber[500] }} />,
          label: "Suspended",
          style: {
            borderColor: amber[500],
          },
        };
      } else if (params.value === "TER") {
        return {
          icon: <Clear style={{ fill: red[500] }} />,
          label: "Terminated",
          style: {
            borderColor: red[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  function getTenantTypeChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "Company") {
        return {
          icon: <Apartment style={{ fill: deepOrange[500] }} />,
          label: "Company",
          style: {
            borderColor: deepOrange[500],
          },
        };
      } else if (params.value === "Individual") {
        return {
          icon: <Person style={{ fill: green[500] }} />,
          label: "Individual",
          style: {
            borderColor: green[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  const columns = useMemo(
    () => [
      {
        headerName: "Billing Code",
        field: "billingCode",
        minWidth: 150,
        flex: 1.5,
      },
      {
        headerName: "Unit(s)",
        field: "unitNames",
        minWidth: 100,
        flex: 1,
        sortComparator: sortAlphaNum,
      },
      {
        headerName: "Time Left",
        field: "expirationDate",
        minWidth: 90,
        flex: 0.9,
        valueFormatter: (row) => {
          let days = dateDifference(new Date(), new Date(row.value));
          if (isNullUndefined(row.value)) {
            return "∞";
          }
          if (days < 0) {
            return "Expired";
          }
          if (days >= 365) {
            return " 1+ year";
          }
          if (days >= 180) {
            return "6+ months";
          }
          if (days >= 90) {
            return "3+ months";
          }
          if (days >= 30) {
            return "1+ month";
          }
          return days.toFixed(0) + " days";
        },
      },
      {
        headerName: "Rent Frequency",
        field: "billingPeriod",
        minWidth: 135,
        fleX: 1.35,
        valueFormatter: (row) => {
          if (row.value === "WEEK") {
            return "Weekly";
          } else if (row.value === "MNTH") {
            return "Monthly";
          } else if (row.value === "ANU") {
            return "Annually";
          } else if (row.value === "QT") {
            return "Quarterly";
          } else return "N/A";
        },
      },
      {
        headerName: "Type",
        field: "leaseType",
        minWidth: 110,
        flex: 1.1,
        valueFormatter: (row) => {
          if (row.value === "COM") {
            return "Commercial";
          } else if (row.value === "RES") {
            return "Residential";
          }
        },
      },
      {
        headerName: "Periodic Charge",
        field: "periodicCharge",
        minWidth: 140,
        flex: 1.4,
        valueFormatter: (row) => {
          return formatCurrency(row.value);
        },
      },
      {
        headerName: "Tenant",
        field: "tenant",
        minWidth: 200,
        flex: 2,
        renderCell: renderCellExpand,
      },
      {
        field: "tenantType",
        headerName: "Tenant Type",
        minWidth: 150,
        flex: 2,
        renderCell: (params) => {
          return (
            <Chip variant="outlined" size="small" {...getTenantTypeChipProps(params)} />
          );
        },
      },
      {
        headerName: "Balance",
        field: "balance",
        minWidth: 120,
        flex: 1.2,
        valueFormatter: (row) => {
          return formatCurrency(row.value);
        },
      },
      {
        headerName: "Status",
        field: "status",
        width: "115",
        renderCell: (params) => {
          return (
            <Chip variant="outlined" size="small" {...getChipProps(params)} />
          );
        },
      },
      {
        headerName: "Actions",
        field: "actions",
        width: 100,
        type: "actions",
        getActions: (params) => {
          let arr = [];
          arr.push(
            <GridActionsCellItem
              icon={<Visibility />}
              onClick={() => handleViewClick(params.row)}
              label="View"
              showInMenu
            />,
          );
          if (!(params.row.status === "DRF" && !params.row.hasTransactions)) {
            arr.push(
              <GridActionsCellItem
                icon={<Add />}
                label="Add Note"
                onClick={() => handleNoteClick(params.row)}
                showInMenu
              />,
            );
          }

          if (
            user.proxyRole === "BLDIR" ||
            user.proxyRole === "BLDMG" ||
            user.proxyRole === "CS" ||
            user.proxyRole === "ACC"
          ) {
            if (!(params.row.status === "DRF" && !params.row.hasTransactions)) {
              arr.push(
                <GridActionsCellItem
                  icon={<Contacts />}
                  label="Next of Kin"
                  onClick={() => handleContactClick(params.row)}
                  showInMenu
                />,
              );
            }
            arr.push(
              <GridActionsCellItem
                icon={<LocalAtm />}
                label="Receive Payment"
                onClick={() => handlePaymentClick(params.row)}
                showInMenu
              />,
            );
            if (params.row.status === "ACT" || params.row.status === "SUP") {
              arr.push(
                <GridActionsCellItem
                  icon={<CreditCard />}
                  label="Issue Credit"
                  onClick={() => handleCreditClick(params.row)}
                  showInMenu
                />,
              );
              arr.push(
                <GridActionsCellItem
                  icon={<NearMe />}
                  label="Issue Charge"
                  onClick={() => handleChargeClick(params.row)}
                  showInMenu
                />,
              );
            }
          }

          if (user.proxyRole === "BLDMG") {
            if (params.row.status === "DRF") {
              arr.push(
                <GridActionsCellItem
                  icon={<Edit />}
                  label="Edit"
                  onClick={() => handleEditClick(params.row)}
                  showInMenu
                />,
              );

              arr.push(
                <GridActionsCellItem
                  icon={<Done />}
                  label="Activate"
                  onClick={() => handleActivateDraftLeaseClick(params.row)}
                  showInMenu
                />,
              );

              if (params.row.status === "DRF" && !params.row.hasTransactions) {
                arr.push(
                  <GridActionsCellItem
                    icon={<Clear />}
                    label="Delete"
                    onClick={() => handleDeleteDraftLeaseClick(params.row)}
                    showInMenu
                  />,
                );
              }

              if (params.row.status === "DRF" && params.row.hasTransactions) {
                arr.push(
                  <GridActionsCellItem
                    icon={<Clear />}
                    label="Terminate"
                    onClick={() => handleTerminateClick(params.row)}
                    showInMenu
                  />,
                );
              }
            }

            if (params.row.status === "ACT") {
              arr.push(
                <GridActionsCellItem
                  icon={<Clear />}
                  label="Terminate"
                  onClick={() => handleTerminateClick(params.row)}
                  showInMenu
                />,
              );
            }
          }

          if (user.proxyRole === "BLDIR" || user.proxyRole === "SYSAD") {
            if (params.row.status === "ACT") {
              arr.push(
                <GridActionsCellItem
                  icon={<Edit />}
                  label="Edit"
                  onClick={() => handleActiveEditClick(params.row)}
                  showInMenu
                />,
              );

              arr.push(
                <GridActionsCellItem
                  icon={<Pause />}
                  label="Suspend"
                  onClick={() => handleSuspendClick(params.row)}
                  showInMenu
                />,
              );

              arr.push(
                <GridActionsCellItem
                  icon={<Clear />}
                  label="Terminate"
                  onClick={() => handleTerminateClick(params.row)}
                  showInMenu
                />,
              );
            }

            if (params.row.status === "DRF") {
              arr.push(
                <GridActionsCellItem
                  icon={<Edit />}
                  label="Edit"
                  onClick={() => handleEditClick(params.row)}
                  showInMenu
                />,
              );

              arr.push(
                <GridActionsCellItem
                  icon={<Done />}
                  label="Activate"
                  onClick={() => handleActivateDraftLeaseClick(params.row)}
                  showInMenu
                />,
              );

              if (params.row.status === "DRF" && !params.row.hasTransactions) {
                arr.push(
                  <GridActionsCellItem
                    icon={<Clear />}
                    label="Delete"
                    onClick={() => handleDeleteDraftLeaseClick(params.row)}
                    showInMenu
                  />,
                );
              }

              if (params.row.status === "DRF" && params.row.hasTransactions) {
                arr.push(
                  <GridActionsCellItem
                    icon={<Clear />}
                    label="Terminate"
                    onClick={() => handleTerminateClick(params.row)}
                    showInMenu
                  />,
                );
              }
            }

            if (params.row.status === "SUP") {
              arr.push(
                <GridActionsCellItem
                  icon={<PlayArrow />}
                  label="Reactivate"
                  onClick={() => handleReActivateClick(params.row)}
                  showInMenu
                />,
              );
            }
          }
          return arr;
        },
      },
    ],
  );

  return (
    <Permit
      roles="BLDIR,BLDMG,REC,OWN,CS"
      services="PREMIUM,CORE,LEAN"
      noPermittedServiceMessage={{
        title: "Access Denied",
        body: (
          <>
            Your current role and/or facility is not permitted to view this
            page. <br /> Please contact your system admin if you feel this is an
            error.
          </>
        ),
      }}
    >
      <ResponsiveRow
        sx={{
          flexDirection: "column",
          flexWrap: "nowrap",
          width: "100%",
          height: "auto",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        {task === "" && (
          <TopBarContainer
            sx={{
              flexWrap: "nowrap",
              flexDirection: { xs: "column", xl: "row" },
              width: { xs: "100%", lg: "80%" },
            }}
            container
          >
            <ResponsiveRow
              item
              sx={{
                flexWrap: "nowrap",
                flexDirection: { xs: "column", lg: "row" },
                gap: "10px",
                width: { xs: "100%", xl: "40%" },
                height: "auto",
                textAlign: { xs: "center", lg: "start" },
              }}
            >
              <FormControl
                sx={{
                  width: { xs: "100%", lg: "32%" },
                }}
              >
                <InputLabel>Search Billing Code</InputLabel>
                <OutlinedInput
                  id="searchRef"
                  label="Search Billing Code"
                  sx={{
                    width: { xs: "100%", lg: "100%" },
                  }}
                  onChange={(event) => onTextChange(event)}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: { xs: "100%", lg: "32%" },
                }}
              >
                <InputLabel>Search Tenant</InputLabel>
                <OutlinedInput
                  id="searchTenant"
                  label="Search Tenant"
                  sx={{
                    width: { xs: "100%", lg: "100%" },
                  }}
                  onChange={(event) => onTextChange(event)}
                />
              </FormControl>
              <FormControl
                  sx={{
                    width: { xs: "100%", lg: "32%" },
                  }}
              >
                <InputLabel>Search Unit Name</InputLabel>
                <OutlinedInput
                    id="searchUnit"
                    label="Search Unit Name"
                    sx={{
                      width: { xs: "100%", lg: "100%" },
                    }}
                    onChange={(event) => onTextChange(event)}
                />
              </FormControl>
            </ResponsiveRow>

            <ResponsiveRow
              sx={{
                flexDirection: { xs: "column", lg: "row" },
                flexWrap: "nowrap",

                width: { xs: "100%", xl: "60%" },
                height: "auto",

                padding: 0,
                justifyContent: { xs: "center", lg: "flex-end" },
              }}
              item
            >
              <Permit roles="BLDIR,BLDMG,ACC,CS">
                <TopBarContainedBrandButton
                  onClick={handleAddLeaseClick}
                  sx={{ width: { xs: "100%", lg: "150px" } }}
                >
                  Add Lease{" "}
                </TopBarContainedBrandButton>
              </Permit>

              <SplitButton buttons={leaseButtons} />

              <SplitButton buttons={resendButtons} />
            </ResponsiveRow>
          </TopBarContainer>
        )}
        {(task === "Create" ||
          task === "Edit" ||
          task === "ActiveLeaseEdit") && (
          <AddLeaseModal
            selectedLease={selectedLease}
            task={task}
            handleAddLeaseClose={handleAddLeaseClose}
          />
        )}
        {showIncrementRentModal && (
          <IncrementRentModal
            selectedLeaseIds={rowSelectionModel}
            showIncrementRentModal={showIncrementRentModal}
            handleIncrementRentClose={handleIncrementRentClose}
          />
        )}
        {task === "Unit Swap" && (
          <LeaseUnitSwapModal
            selectedLease={selectedLease}
            task={task}
            handleSwapLeaseUnitClose={handleSwapLeaseUnitClose}
          />
        )}
        {(task === "View" || task === "Unit Swap") && (
          <LeaseView
            handleStatementYearChange={handleStatementYearChange}
            statementYear={statementYear}
            handleUnitSwapClick={handleUnitSwapClick}
            selectedLease={selectedLease}
            handleVoidClick={handleVoidClick}
            setTask={setTask}
            rsrs={rsrs}
            fetchRsrs={fetchRsrs}
            loading={loading}
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
            setPaginationModel={setPaginationModel}
          />
        )}
        {task === "" && (
          <ResponsiveRow marginTop={"1rem"}>
            <MuiDataGrid
              dataGridColumns={columns}
              dataGridRows={leases}
              loading={loading}
              height="60vh"
              totalRows={totalLeases}
              currentSelectionModel={rowSelectionModel}
              handleSelectedRows={setRowSelectionModel}
              handlePageLoad={setPaginationModel}
              serverPagination={true}
            />
          </ResponsiveRow>
        )}
        {/*RECEIVE PAYMENT MODAL*/}
        {paymentModal && (
          <ReceivePayment
            showPaymentModal={paymentModal}
            handlePaymentClose={handlePaymentClose}
            paymentMode={"Lease"}
            contract={selectedLease}
            savePayment={savePayment}
          />
        )}
        {/*CREATE CREDIT MODAL*/}
        {creditModal && (
          <CreditNote
            open={creditModal}
            onClose={handleCreditClose}
            voiditem={voiditem}
            leaseid={selectedLease && selectedLease.id}
          />
        )}
        {/*CREATE CHARGE MODAL*/}
        {chargeModal && (
          <DebitNote
            open={chargeModal}
            onClose={handleChargeClose}
            voiditem={voiditem}
            leaseid={selectedLease && selectedLease.id}
            leaseIds={
              bulkChargeAction && rowSelectionModel.length > 1
                ? rowSelectionModel
                : []
            }
            bulkChargeAction={bulkChargeAction}
          />
        )}
        {/*ADD NEW USER MODAL*/}
        {addUserModal && (
          <AddNewUser
            openModal={addUserModal}
            closeModal={handleAddUserClose}
            searchedIdType={idTypeSearch}
            searchedIdNo={idNoSearch}
            saveUser={handlePersonOrgSelect}
            manageUsers={false}
          />
        )}
        {/*ADD NOTE MODAL*/}
        {noteModal && (
          <AddNoteModal
            handleNoteClose={handleNoteClose}
            onTextChange={onTextChange}
            noteModal={noteModal}
            saveNote={saveNote}
            selectedLease={selectedLease}
            note={note}
          />
        )}
        {/*Download/Export Document via Email... Shared Modal*/}
        {downloadModal && (
          <ExportDocumentsModal
            showExportDocumentsModal={downloadModal}
            handleExportDocumentsClose={handleDownloadClose}
            title={titleText}
            severity={severityText}
            body={bodyText}
            contract={"Lease"}
            handleIncludeDetailToggle={handleIncludeLeaseDetailToggle}
            handleStatementYearChange={handleStatementYearChange}
            includeDetails={includeLeaseDetail}
            statementYear={statementYear}
            handleExportDocuments={positiveExportDocsAction}
            handleCancel={handleDownloadClose}
          />
        )}
        {/*CONFIRMATION MODAL*/}
        {showConfirmationModal && (
          <ConfirmationModal
            showConfirmationModal={showConfirmationModal}
            handleConfirmationClose={handleConfirmationClose}
            title={titleText}
            severity={severityText}
            body={bodyText}
            positiveText={positiveText}
            negativeText={negativeText}
            positiveAction={positiveAction}
            negativeAction={handleConfirmationClose}
          />
        )}
        {/*SUSPEND MODAL*/}
        {suspendModal && (
          <SuspendLeaseModal
            suspendReActivateLeaseForm={suspendReActivateLeaseForm}
            handleSuspendReactivateClose={handleSuspendReactivateClose}
            suspendModal={suspendModal}
            task={task}
            selectedLease={selectedLease}
            statusChangeReason={statusChangeReason}
            onTextChange={onTextChange}
          />
        )}
        {/*TERMINATE MODAL*/}
        {terminateModal && (
          <ContractTermination
            showTerminateModal={terminateModal}
            handleTerminateClose={handleTerminateClose}
            terminationMode={"Lease"}
            terminateItem={terminateItem}
            contract={selectedLease}
            terminateContract={terminateLease}
          />
        )}
        {/*LEASE CONTACT MODAL*/}
        {contactModal && (
          <ContractContactModal
            contractType={"Lease"}
            contactModal={contactModal}
            handleContactClose={handleContactClose}
            setShowAddNewContact={setShowAddNewContact}
            handlePersonOrgSelect={handlePersonOrgSelect}
            selectedContract={selectedLease}
            contactTableRows={contactTableRows}
            showAddNewContact={showAddNewContact}
            showAddNewContactForm={showAddNewContactForm}
          />
        )}
      </ResponsiveRow>
    </Permit>
  );
}
